@use '../../scss/abstracts/mixins' as *;
@use '../../scss/abstracts/variables' as *;

.section {
  background: #201b14;
  padding: 4.5rem 0 10rem;

  @media screen and (max-width: $tablet-portrait) {
    padding: 6rem 0;
  }
}

.wrap {
  @include content-size;
  padding: 0 10.5rem;

  @media (max-width: $tablet-landscape) {
    padding: 0 6rem;
  }

  @media (max-width: $tablet-portrait) {
    padding: 0 4.2rem;
  }

  @media (max-width: $phone) {
    padding: 0 1.8rem;
  }
}

.header {
  text-align: center;
  max-width: 64rem;
  margin: 0 auto 5.2rem;
}

.eyebrow {
  font-family: 'Inter', sans-serif;
  font-size: 1rem;
  font-weight: 700;
  letter-spacing: 0.28em;
  text-transform: uppercase;
  color: #c9a44d;
  margin-bottom: 0.8rem;
}

.heading {
  font-family: 'Playfair Display', serif;
  font-weight: 600;
  font-size: 3.2rem;
  color: #f3ecdf;
  margin: 1.4rem 0 1.4rem;

  em,
  i {
    font-style: italic;
    color: #c9a44d;
  }
}

.accent {
  font-family: 'Playfair Display', serif;
  font-style: italic;
  color: #c9a44d;
}

.lead {
  font-family: 'Playfair Display', serif;
  font-style: italic;
  font-size: 1.5rem;
  color: #cdc2aa;
  line-height: 1.7;
}

.note {
  font-family: 'Inter', sans-serif;
  font-size: 1.2rem;
  font-style: italic;
  color: #8a7a5f;
  margin-top: 0.8rem;
}

.ideas {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 2.4rem;

  @media (max-width: $tablet-landscape) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: $phone) {
    grid-template-columns: 1fr;
  }
}

.idea {
  border-radius: 0;
  overflow: hidden;
  cursor: pointer;

  &:focus-visible {
    outline: 2px solid #c9a44d;
    outline-offset: -2px;
  }
}

.media {
  position: relative;
  height: 36rem;
  background: linear-gradient(135deg, #6b5638, #3c2c1a);

  img {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.6s;
  }

  &:hover img {
    transform: scale(1.07);
  }
}

.overlay {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding: 2.6rem 2.4rem;
  background: linear-gradient(180deg, rgba(15, 12, 7, 0) 28%, rgba(15, 12, 7, 0.92));
}

.days {
  align-self: flex-start;
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: #241a08;
  background: #bf8a2e;
  padding: 0.6rem 1.1rem;
  border-radius: 0;
  margin-bottom: 1.2rem;
  white-space: nowrap;
}

.overlay h3 {
  font-family: 'Playfair Display', serif;
  font-size: 1.8rem;
  font-weight: 600;
  color: #f7f1e5;
  line-height: 1.2;
  margin-bottom: 0.8rem;
}

.meta {
  font-family: 'Inter', sans-serif;
  font-size: 1.05rem;
  color: #d8ccb4;
  margin-bottom: 1.2rem;
}

.cta {
  align-self: flex-start;
  font-family: 'Inter', sans-serif;
  font-size: 0.9rem;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: #c9a44d;
  transition: color 0.2s ease;

  .idea:hover & {
    color: #e8c374;
  }
}